import { useEffect, useRef, useState } from "react"
import { Box } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"

export function ColumnManagerProvider({ manager, scopeClass = "column-manager-scope", children }) {
    const [hiddenFields] = useState(() => new Set())
    const style = useRef()
    const pinnedField = manager?.columnState?.pinnedField

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(unhidePinnedField, [pinnedField])

    return (
        <Bound {...manager} hideColumn={hideColumn} autoHiddenColumns={hiddenFields}>
            {/* hideColumn writes the display:none rules for auto-hidden columns into this element */}
            <style ref={style} />
            <Box className={scopeClass}>{children}</Box>
        </Bound>
    )

    function hideColumn(field, hidden) {
        // A pinned column is always visible
        if (hidden && field === pinnedField) hidden = false
        if (hidden) {
            hiddenFields.add(field)
        } else {
            hiddenFields.delete(field)
        }
        if (!style.current) return
        const selectors = [...hiddenFields].map(toSelector).join(",")
        style.current.textContent = selectors ? `${selectors} { display: none; }` : ""
    }

    function unhidePinnedField() {
        if (pinnedField && hiddenFields.has(pinnedField)) hideColumn(pinnedField, false)
    }

    function toSelector(field) {
        return `.${scopeClass} table th[data-col="${field}"], .${scopeClass} table td[data-col="${field}"]`
    }
}
